import { Link, useParams } from 'react-router';
import { Menu, ChevronRight } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useAuthContext } from '@/contexts/auth-context';
import { findPage, findRole } from './docs-manifest';

interface Props {
  onMenuClick?: () => void;
}

export function DocsTopBar({ onMenuClick }: Props) {
  const { role, page } = useParams();
  const { isAuthenticated } = useAuthContext();

  const roleEntry = findRole(role);
  const pageEntry = findPage(role, page ?? 'README');

  return (
    <header className="sticky top-0 z-10 flex h-14 items-center gap-4 border-b bg-background px-4 lg:px-6">
      {onMenuClick && (
        <Button variant="ghost" size="icon" className="lg:hidden" onClick={onMenuClick}>
          <Menu className="h-5 w-5" />
        </Button>
      )}
      <nav className="flex items-center gap-1 text-sm text-muted-foreground">
        <Link to="/docs" className="hover:text-foreground">
          Docs
        </Link>
        {roleEntry && (
          <>
            <ChevronRight className="h-3 w-3" />
            <Link to={`/docs/${roleEntry.slug}`} className="hover:text-foreground">
              {roleEntry.label}
            </Link>
          </>
        )}
        {pageEntry && pageEntry.slug !== 'README' && (
          <>
            <ChevronRight className="h-3 w-3" />
            <span className="text-foreground">{pageEntry.title}</span>
          </>
        )}
      </nav>
      <div className="ml-auto">
        {isAuthenticated ? (
          <Link to="/" className="text-sm text-primary underline">
            Back to dashboard →
          </Link>
        ) : (
          <Link to="/login" className="text-sm text-primary underline">
            Sign in
          </Link>
        )}
      </div>
    </header>
  );
}
